;(() => {
  window.PRODUCT_CACHE = window.PRODUCT_CACHE || {}
  let currentVariant = null,
    currentLashValue = '',
    isFirstLoaded = false

  if (!customElements.get('lash-bundle-options')) {
    class LashBundleOptions extends HTMLElement {
      constructor() {
        super()
        this.main = this.closest('section[data-main-product]')
        this.wrapper = this.closest('[data-component="product/buy-panel"]')
        this.form = this.closest('form')
        this.bundlesLink = this.querySelector('[data-bundles-link]')
        this.atcWrapper = this.form.querySelector('[data-hook="atc-wrapper"]')
        this.LengthOptions = this.form.querySelectorAll('input[name="Length"]')
        this.atcButon = this.form.querySelector('[data-component="product/product-atc"]')

        this.init()

        this.addEventListener('change', this.onOptionChange.bind(this))
        document.addEventListener('product:variant:change', this.saveSelectedVariant.bind(this))
        // this.LengthOptions.forEach(option => {
        //   option.addEventListener('change', this.updateCurrentVariant.bind(this))
        // })

        // document.addEventListener('product:product-swatches:click', this.saveSelectedOption.bind(this))
      }

      init() {
        const optionOneLash = this.querySelector('#single')
        const optionThreeLash = this.querySelector('#three-pack')
        const optionBundle = this.querySelector('#bundle')
        setTimeout(() => {
          const defaultSelectedOption = this.querySelector('input[name="lash-radio-group"]:checked').value
          if (defaultSelectedOption === 'bundle') {
            this.bundlesLink.classList.remove('hidden')
            this.atcWrapper.classList.add('!hidden')
          }
        }, 200)
        ;[optionOneLash, optionThreeLash].forEach((input) => {
          const mappedProduct = input.getAttribute('data-mapping')
          const url = `/products/${mappedProduct}`
          input.layout = this.getProductLayout(url)
          if (optionBundle) {
            if (input.id === 'single') {
              optionBundle.layout = input.layout
            }
          }
        })

        if (currentLashValue) {
          const isSingle = currentLashValue === 'single'
          const isThreePack = currentLashValue === 'three-pack'
          const selectedValue = this.form.querySelector('input[name="lash-radio-group"]:checked').value
          if (optionBundle) {
            const isBundle = currentLashValue === 'bundle'
            if (isBundle) {
              optionBundle.checked = true
              // if(!isFirstLoaded){
              //   optionBundle.dispatchEvent(new Event('change'));
              // }
            }
          } else {
            currentLashValue = selectedValue
            if (currentLashValue === 'bundle') {
              optionBundle.dispatchEvent(new Event('change'))
            }
          }
          setTimeout(() => {
            if (currentLashValue != 'bundle') {
              this.atcWrapper.classList.remove('!hidden')
              this.bundlesLink.classList.add('hidden')
            }
          }, 200)

          this.bundlesLink.classList.toggle('hidden', isSingle || isThreePack)
          this.atcWrapper.classList.toggle('!hidden', !(isSingle || isThreePack))
        }
        isFirstLoaded = true
      }

      saveSelectedVariant(evt, data) {
        currentVariant = evt.detail.variant
      }

      updateCurrentVariant(evt) {
        currentVariant = { option1: evt.target.value }
      }

      async onOptionChange(event) {
        const input = event.target
        const selectedValue = event.target.value
        const isSingle = selectedValue === 'single'
        const isThreePack = selectedValue === 'three-pack'
        currentLashValue = selectedValue

        const mappedProduct = this.querySelector('input:checked').getAttribute('data-mapping')
        const selectedLength = this.form.querySelector('input[name="Length"]:checked')?.value

        const url = `/products/${mappedProduct}`
        window.history.replaceState({}, '', url)
        const productSection = this.closest('[data-main-product]')
        const reviewsSection = document.getElementById('stamped-main-widget')

        const [newProductLayout, newReviewsLayout] = await input.layout
        productSection.outerHTML = newProductLayout
        reviewsSection.outerHTML = newReviewsLayout
        StampedFn.reloadUGC()
        window.setFormListeners()
        const updateMappedProductSwatch = document.querySelector('product-swatches')
        if (updateMappedProductSwatch) {
          updateMappedProductSwatch.querySelectorAll('li').forEach((link) => {
            const anchor = link.querySelector('a')
            if (anchor) {
              const getUrl = anchor.getAttribute('data-url')
              const getMappedUrl = anchor.getAttribute('data-mapped')
              if (getMappedUrl) {
                // Update the href attribute with the new URL
                if (selectedValue == 'three-pack') {
                  anchor.setAttribute('href', getMappedUrl)
                }
                if (selectedValue == 'single') {
                  anchor.setAttribute('href', getUrl)
                }
                let currenturl = window.location.href
                if (anchor.href === currenturl) {
                  link.classList.add('on')
                }
              }
            }
          })
        }
      }

      async getProductLayout(url) {
        if (window.PRODUCT_CACHE[url]) return window.PRODUCT_CACHE[url]

        const response = await fetch(url)
        const html = await response.text()
        const newDom = new DOMParser().parseFromString(html, 'text/html')
        const productSection = newDom.querySelector('[data-main-product]')
        const reviewsSection = newDom.getElementById('stamped-main-widget')

        window.PRODUCT_CACHE[url] = [productSection.outerHTML, reviewsSection.outerHTML]
        return window.PRODUCT_CACHE[url]
      }
    }

    customElements.define('lash-bundle-options', LashBundleOptions)
  }
})()
